// This is auto generated files. DO NOT EDIT DIRECTLY
import type { Exact, InputMaybe, Locales, Scalars, ArticlePageWhereInput, PersonPageWhereInput, LocationPageWhereInput, PageBaseWhereInput, PageBaseOrderByInput } from './cms-types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInit,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ArticleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  mediatype?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  author?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<ArticlePageWhereInput>;
}>;


export type ArticleListingQuery = { __typename?: 'Query', ArticlePage?: { __typename?: 'ArticlePageOutput', total?: number | null, items?: Array<{ __typename?: 'ArticlePage', Name?: string | null, Url?: string | null, Title?: string | null, PreviewTitle?: string | null, PreviewDescription?: string | null, ArticlePublishDate?: any | null, HidePublishDate?: any | null, ReadTimeInMins?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null, GuidValue?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null } | { __typename?: 'LocationPage' } | { __typename?: 'MapAndLocationListingPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'ProductCategoryPage' } | { __typename?: 'ProductPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardNoMainNavigationPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, Authors?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ArticleListingPage' } | { __typename: 'ArticlePage' } | { __typename: 'Content' } | { __typename: 'Country' } | { __typename: 'DAMImageAsset' } | { __typename: 'HomePage' } | { __typename: 'ImageFile' } | { __typename: 'LocationPage' } | { __typename: 'MapAndLocationListingPage' } | { __typename: 'NotFoundPage' } | { __typename: 'PageBase' } | { __typename: 'PdfFile' } | { __typename: 'PeopleListingPage' } | { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null } | { __typename?: 'LocationPage' } | { __typename?: 'MapAndLocationListingPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'ProductCategoryPage' } | { __typename?: 'ProductPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardNoMainNavigationPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | { __typename: 'ProductCategoryPage' } | { __typename: 'ProductPage' } | { __typename: 'SearchPage' } | { __typename: 'StandardNoMainNavigationPage' } | { __typename: 'StandardPage' } | { __typename: 'VectorImageFile' } | null } | null } | null> | null, MediaTypeCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'ArticlePageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, MediaTypeCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null, Authors?: { __typename?: 'ContentAreaItemModelSearchFacet', ContentLink?: { __typename?: 'ContentModelReferenceSearchFacet', GuidValue?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null } | null };

export type LocationListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationPageWhereInput>;
}>;


export type LocationListingQuery = { __typename?: 'Query', LocationPage?: { __typename?: 'LocationPageOutput', total?: number | null, items?: Array<{ __typename?: 'LocationPage', PreviewTitle?: string | null, Title?: string | null, PreviewDescription?: string | null, Address?: string | null, PhoneNumber?: string | null, EmailAddress?: string | null, Latitude?: string | null, Longitude?: string | null, Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null } | { __typename?: 'LocationPage' } | { __typename?: 'MapAndLocationListingPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'ProductCategoryPage' } | { __typename?: 'ProductPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardNoMainNavigationPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null, RegionCategories?: Array<{ __typename?: 'CategoryModel', Id?: number | null, Name?: string | null, Description?: string | null } | null> | null } | null> | null, facets?: { __typename?: 'LocationPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null } | null };

export type PeopleListingQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<PersonPageWhereInput>;
}>;


export type PeopleListingQuery = { __typename?: 'Query', PersonPage?: { __typename?: 'PersonPageOutput', total?: number | null, items?: Array<{ __typename?: 'PersonPage', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, PreviewDescription?: string | null, Role?: string | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null } | { __typename?: 'LocationPage' } | { __typename?: 'MapAndLocationListingPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'ProductCategoryPage' } | { __typename?: 'ProductPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardNoMainNavigationPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null } | null> | null, facets?: { __typename?: 'PersonPageFacet', Status?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null, RegionCategories?: { __typename?: 'CategoryModelFacet', Name?: Array<{ __typename?: 'StringFacet', name?: string | null } | null> | null } | null } | null } | null };

export type SearchBlockQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locales> | Locales>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contenttype?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  where?: InputMaybe<PageBaseWhereInput>;
  orderBy?: InputMaybe<PageBaseOrderByInput>;
}>;


export type SearchBlockQuery = { __typename?: 'Query', PageBase?: { __typename?: 'PageBaseOutput', total?: number | null, items?: Array<{ __typename?: 'PageBase', PreviewTitle?: string | null, Name?: string | null, Url?: string | null, ContentType?: Array<string | null> | null, PreviewDescription?: string | null, DisplayCategory?: string | null, FileSize?: string | null, _score?: number | null, _fulltext?: Array<string | null> | null, ContentLink?: { __typename?: 'ContentModelReference', GuidValue?: string | null, Url?: string | null } | null, PreviewImage?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null> | null, facets?: { __typename?: 'PageBaseFacet', ContentType?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null } | null } | null };

type Author_ArticleListingPage_Fragment = { __typename: 'ArticleListingPage' };

type Author_ArticlePage_Fragment = { __typename: 'ArticlePage' };

type Author_Content_Fragment = { __typename: 'Content' };

type Author_Country_Fragment = { __typename: 'Country' };

type Author_DamImageAsset_Fragment = { __typename: 'DAMImageAsset' };

type Author_HomePage_Fragment = { __typename: 'HomePage' };

type Author_ImageFile_Fragment = { __typename: 'ImageFile' };

type Author_LocationPage_Fragment = { __typename: 'LocationPage' };

type Author_MapAndLocationListingPage_Fragment = { __typename: 'MapAndLocationListingPage' };

type Author_NotFoundPage_Fragment = { __typename: 'NotFoundPage' };

type Author_PageBase_Fragment = { __typename: 'PageBase' };

type Author_PdfFile_Fragment = { __typename: 'PdfFile' };

type Author_PeopleListingPage_Fragment = { __typename: 'PeopleListingPage' };

type Author_PersonPage_Fragment = { __typename: 'PersonPage', Name?: string | null, Role?: string | null, PreviewDescription?: string | null, HeadshotImage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ArticleListingPage' } | { __typename?: 'ArticlePage' } | { __typename?: 'Content' } | { __typename?: 'Country' } | { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null } | { __typename?: 'HomePage' } | { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null } | { __typename?: 'LocationPage' } | { __typename?: 'MapAndLocationListingPage' } | { __typename?: 'NotFoundPage' } | { __typename?: 'PageBase' } | { __typename?: 'PdfFile' } | { __typename?: 'PeopleListingPage' } | { __typename?: 'PersonPage' } | { __typename?: 'ProductCategoryPage' } | { __typename?: 'ProductPage' } | { __typename?: 'SearchPage' } | { __typename?: 'StandardNoMainNavigationPage' } | { __typename?: 'StandardPage' } | { __typename?: 'VectorImageFile' } | null } | null };

type Author_ProductCategoryPage_Fragment = { __typename: 'ProductCategoryPage' };

type Author_ProductPage_Fragment = { __typename: 'ProductPage' };

type Author_SearchPage_Fragment = { __typename: 'SearchPage' };

type Author_StandardNoMainNavigationPage_Fragment = { __typename: 'StandardNoMainNavigationPage' };

type Author_StandardPage_Fragment = { __typename: 'StandardPage' };

type Author_VectorImageFile_Fragment = { __typename: 'VectorImageFile' };

export type AuthorFragment = Author_ArticleListingPage_Fragment | Author_ArticlePage_Fragment | Author_Content_Fragment | Author_Country_Fragment | Author_DamImageAsset_Fragment | Author_HomePage_Fragment | Author_ImageFile_Fragment | Author_LocationPage_Fragment | Author_MapAndLocationListingPage_Fragment | Author_NotFoundPage_Fragment | Author_PageBase_Fragment | Author_PdfFile_Fragment | Author_PeopleListingPage_Fragment | Author_PersonPage_Fragment | Author_ProductCategoryPage_Fragment | Author_ProductPage_Fragment | Author_SearchPage_Fragment | Author_StandardNoMainNavigationPage_Fragment | Author_StandardPage_Fragment | Author_VectorImageFile_Fragment;

export type CategoryFacetFragment = { __typename?: 'CategoryModelFacet', Description?: Array<{ __typename?: 'StringFacet', name?: string | null, count?: number | null } | null> | null };

export type CountryFragment = { __typename?: 'Country', Name?: string | null, PlaceId?: string | null };

type Image_ArticleListingPage_Fragment = { __typename?: 'ArticleListingPage' };

type Image_ArticlePage_Fragment = { __typename?: 'ArticlePage' };

type Image_Content_Fragment = { __typename?: 'Content' };

type Image_Country_Fragment = { __typename?: 'Country' };

type Image_DamImageAsset_Fragment = { __typename?: 'DAMImageAsset', Name?: string | null, Url?: string | null, AltText?: string | null };

type Image_HomePage_Fragment = { __typename?: 'HomePage' };

type Image_ImageFile_Fragment = { __typename?: 'ImageFile', Name?: string | null, Url?: string | null, Title?: string | null, Width?: number | null, Height?: number | null, AltText?: string | null };

type Image_LocationPage_Fragment = { __typename?: 'LocationPage' };

type Image_MapAndLocationListingPage_Fragment = { __typename?: 'MapAndLocationListingPage' };

type Image_NotFoundPage_Fragment = { __typename?: 'NotFoundPage' };

type Image_PageBase_Fragment = { __typename?: 'PageBase' };

type Image_PdfFile_Fragment = { __typename?: 'PdfFile' };

type Image_PeopleListingPage_Fragment = { __typename?: 'PeopleListingPage' };

type Image_PersonPage_Fragment = { __typename?: 'PersonPage' };

type Image_ProductCategoryPage_Fragment = { __typename?: 'ProductCategoryPage' };

type Image_ProductPage_Fragment = { __typename?: 'ProductPage' };

type Image_SearchPage_Fragment = { __typename?: 'SearchPage' };

type Image_StandardNoMainNavigationPage_Fragment = { __typename?: 'StandardNoMainNavigationPage' };

type Image_StandardPage_Fragment = { __typename?: 'StandardPage' };

type Image_VectorImageFile_Fragment = { __typename?: 'VectorImageFile' };

export type ImageFragment = Image_ArticleListingPage_Fragment | Image_ArticlePage_Fragment | Image_Content_Fragment | Image_Country_Fragment | Image_DamImageAsset_Fragment | Image_HomePage_Fragment | Image_ImageFile_Fragment | Image_LocationPage_Fragment | Image_MapAndLocationListingPage_Fragment | Image_NotFoundPage_Fragment | Image_PageBase_Fragment | Image_PdfFile_Fragment | Image_PeopleListingPage_Fragment | Image_PersonPage_Fragment | Image_ProductCategoryPage_Fragment | Image_ProductPage_Fragment | Image_SearchPage_Fragment | Image_StandardNoMainNavigationPage_Fragment | Image_StandardPage_Fragment | Image_VectorImageFile_Fragment;


export const ImageFragmentDoc = `
    fragment Image on IContent {
  ... on ImageFile {
    Name
    Url
    Title
    Width
    Height
    AltText: Description
  }
  ... on DAMImageAsset {
    Name
    Url
    AltText
  }
}
    `;
export const AuthorFragmentDoc = `
    fragment Author on IContent {
  __typename
  ... on PersonPage {
    Name
    Role
    PreviewDescription
    HeadshotImage {
      Expanded {
        ...Image
      }
    }
  }
}
    `;
export const CategoryFacetFragmentDoc = `
    fragment CategoryFacet on CategoryModelFacet {
  Description(filters: $category) {
    name
    count
  }
}
    `;
export const CountryFragmentDoc = `
    fragment Country on Country {
  Name
  PlaceId
}
    `;
export const ArticleListingDocument = `
    query ArticleListing($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $mediatype: [String!] = [], $author: [String!] = [], $where: ArticlePageWhereInput) {
  ArticlePage(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: {ArticlePublishDate: DESC}
  ) {
    items {
      Name
      Url
      ContentLink {
        Url
        GuidValue
      }
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      Title
      PreviewTitle
      PreviewDescription
      Authors {
        ContentLink {
          Expanded {
            ...Author
          }
        }
      }
      ArticlePublishDate
      HidePublishDate
      ReadTimeInMins
      MediaTypeCategories {
        Id
        Description
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      MediaTypeCategories {
        Name(filters: $mediatype) {
          name
        }
      }
      Authors {
        ContentLink {
          GuidValue(filters: $author) {
            name
            count
          }
        }
      }
    }
  }
}
    ${ImageFragmentDoc}
${AuthorFragmentDoc}`;

export const useArticleListingQuery = <
      TData = ArticleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: ArticleListingQueryVariables,
      options?: Omit<UseQueryOptions<ArticleListingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArticleListingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArticleListingQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ArticleListing'] : ['ArticleListing', variables],
    queryFn: fetcher<ArticleListingQuery, ArticleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, ArticleListingDocument, variables),
    ...options
  }
    )};

export const LocationListingDocument = `
    query LocationListing($locale: [Locales!] = en_AU, $limit: Int = 100, $skip: Int = 0, $where: LocationPageWhereInput) {
  LocationPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        Id
        Url
      }
      PreviewTitle
      Title
      PreviewDescription
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      RegionCategories {
        Id
        Name
        Description
      }
      Address
      PhoneNumber
      EmailAddress
      Latitude
      Longitude
      Url
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name {
          name
          count
        }
        Description {
          name
          count
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export const useLocationListingQuery = <
      TData = LocationListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: LocationListingQueryVariables,
      options?: Omit<UseQueryOptions<LocationListingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LocationListingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LocationListingQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LocationListing'] : ['LocationListing', variables],
    queryFn: fetcher<LocationListingQuery, LocationListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, LocationListingDocument, variables),
    ...options
  }
    )};

export const PeopleListingDocument = `
    query PeopleListing($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $region: [String!] = [], $where: PersonPageWhereInput) {
  PersonPage(locale: $locale, skip: $skip, limit: $limit, where: $where) {
    items {
      ContentLink {
        GuidValue
        Url
      }
      PreviewTitle
      Name
      Url
      PreviewDescription
      Role
      PreviewImage {
        Expanded {
          ...Image
        }
      }
      _fulltext
    }
    total
    facets {
      Status(filters: ["Published"]) {
        name
        count
      }
      RegionCategories {
        Name(filters: $region) {
          name
        }
      }
    }
  }
}
    ${ImageFragmentDoc}`;

export const usePeopleListingQuery = <
      TData = PeopleListingQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: PeopleListingQueryVariables,
      options?: Omit<UseQueryOptions<PeopleListingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PeopleListingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PeopleListingQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PeopleListing'] : ['PeopleListing', variables],
    queryFn: fetcher<PeopleListingQuery, PeopleListingQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, PeopleListingDocument, variables),
    ...options
  }
    )};

export const SearchBlockDocument = `
    query SearchBlock($locale: [Locales!] = en_AU, $limit: Int = 50, $skip: Int = 0, $contenttype: [String!] = [], $where: PageBaseWhereInput, $orderBy: PageBaseOrderByInput) {
  PageBase(
    locale: $locale
    skip: $skip
    limit: $limit
    where: $where
    orderBy: $orderBy
  ) {
    items {
      PreviewTitle
      Name
      Url
      ContentType
      ContentLink {
        GuidValue
        Url
      }
      PreviewDescription
      PreviewImage {
        Url
      }
      DisplayCategory
      FileSize
      _score
      _fulltext
    }
    facets {
      ContentType(filters: $contenttype, limit: 20) {
        name
        count
      }
    }
    total(all: true)
  }
}
    `;

export const useSearchBlockQuery = <
      TData = SearchBlockQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: SearchBlockQueryVariables,
      options?: Omit<UseQueryOptions<SearchBlockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchBlockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchBlockQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SearchBlock'] : ['SearchBlock', variables],
    queryFn: fetcher<SearchBlockQuery, SearchBlockQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, SearchBlockDocument, variables),
    ...options
  }
    )};
